import { ClipboardModule } from '@angular/cdk/clipboard';
import { Component, inject } from '@angular/core';
import { AppVersion, BaseEnvironment } from '@mkp/shared/models';
import { ENVIRONMENT_PROVIDER } from '@mkp/shared/util-environment';
import { LabelColor, LabelComponent, LabelConfig, SnackbarModule } from '@mkp/shared/ui-library';
import { SnackbarService } from '@mkp/shared/util-snackbar';

@Component({
  selector: 'mkp-version',
  templateUrl: './version.component.html',
  styleUrl: './version.component.scss',
  imports: [LabelComponent, ClipboardModule, SnackbarModule],
})
export class VersionComponent {
  private readonly snackbarService = inject(SnackbarService);
  private readonly environment = inject(ENVIRONMENT_PROVIDER);
  readonly version = getVersion(this.environment.version);
  readonly environmentName = this.environment.name;
  readonly labelConfig: LabelConfig = { color: getLabelColor(this.environment.name) };

  onCopied() {
    this.snackbarService.show('Copied to clipboard');
  }
}

const getLabelColor = (environmentName: BaseEnvironment['name']): LabelColor =>
  environmentName === 'dev' ? 'orange' : 'red';
const getVersion = (environmentVersion: BaseEnvironment['version']): AppVersion | 'local' =>
  environmentVersion === 'v0.0.0' ? 'local' : environmentVersion;
